import React, { useEffect } from "react";
import Vanta from "../components/Vanta";
import Nav from "../components/Nav";
import Timeline from "../components/Timeline";
import Works from "../components/Works";
import Skills from "../components/Skills";
import Experience from "../components/Experience";
import Resume from "../components/Resume";
import MileStones from "../components/MileStones";
import Contact from "../components/Contact";

export default function Portfolio() {
  return (
    <div>
      <Nav />
      <Timeline />
      <Vanta />
      <Works />
      <Skills />
      <Experience />
      <Resume />
      <MileStones />
      <Contact />
    </div>
  );
}
